import moment from 'moment-timezone';
import { EventCatalogFilterFormValues } from 'store/types/FormValues';
import { getISODateString } from 'util/Format';

export interface EventCatalogHiddenFilters {
  hideCountryFilter?: boolean;
  hideAgeFilter?: boolean;
}

export const defaultEventCatalogFilterValues: EventCatalogFilterFormValues = {
  startTime: null,
  endTime: null,
  type: [],
  creditType: [],
  location: [],
  distance: '',
  zipCode: '',
  country: '',
  state: '',
  age: '',
};

const SINGLE_VALUE_KEYS: string[] = ['startTime', 'endTime', 'state', 'country', 'age', 'distance', 'zipCode'];
const DATE_KEYS: string[] = ['startTime', 'endTime'];

export const EVENT_CATALOG_FILTER_KEYS: string[] = Object.keys(defaultEventCatalogFilterValues);

const isHiddenFilter = (key: string, { hideCountryFilter, hideAgeFilter }: EventCatalogHiddenFilters): boolean =>
  ((key === 'country' || key === 'state') && !!hideCountryFilter) || (key === 'age' && !!hideAgeFilter);

export const getEventCatalogFilterValues = (search?: string): EventCatalogFilterFormValues => {
  let result: EventCatalogFilterFormValues = { ...defaultEventCatalogFilterValues };

  if (search) {
    new URLSearchParams(search).forEach((value: string, key: string) => {
      if (!EVENT_CATALOG_FILTER_KEYS.includes(key)) {
        return;
      }
      result = { ...result, [key]: SINGLE_VALUE_KEYS.includes(key) ? value : value.split(',').filter(Boolean) };
    });
  }
  return result;
};

export const getEventCatalogFilterSearch = (
  formValues: EventCatalogFilterFormValues,
  currentSearch: string,
  hiddenFilters: EventCatalogHiddenFilters
): string => {
  const currentParams: URLSearchParams = new URLSearchParams(currentSearch);
  const newParams: URLSearchParams = new URLSearchParams(currentSearch);

  EVENT_CATALOG_FILTER_KEYS.forEach((key: string) => newParams.delete(key));
  Object.keys(formValues).forEach((key: string) => {
    if (isHiddenFilter(key, hiddenFilters)) {
      return;
    }

    const value = formValues[key as keyof EventCatalogFilterFormValues];

    if (DATE_KEYS.includes(key)) {
      const dateValue: string | null = value ? getISODateString(moment(value as Date | string)) : null;

      if (dateValue) {
        newParams.set(key, dateValue);
      }
    } else if (value && (!Array.isArray(value) || value.length)) {
      newParams.set(key, value.toString());
    } else if (key === 'country' && currentParams.has('country')) {
      newParams.set(key, '');
    }
  });
  return `?${newParams.toString()}`;
};

const getSortedParams = (search: string): string => {
  const params: URLSearchParams = new URLSearchParams(search);

  params.sort();
  return params.toString();
};

export const isSameSearch = (firstSearch: string, secondSearch: string): boolean =>
  getSortedParams(firstSearch) === getSortedParams(secondSearch);
